module.exports = __webpack_public_path__ + "static/assets/9599fd8ac0e980a9b54528414b3a8a04.svg";